import { useReconcileLedgerSyncConnection } from '@/hooks/useLedgerSync'

/** Props for the invisible per-connection reconciler. */
export interface LedgerSyncConnectionReconcilerProps {
  connectionId: string
  /**
   * True when this row is being RECONNECTED (its stored status is already
   * terminal failed/disconnected). Forwarded to the poll so only `active` stops
   * it — otherwise it would halt after one request (DCP-173, AC.6).
   */
  reconnecting?: boolean
}

/**
 * Invisible component that mounts one `useReconcileLedgerSyncConnection`
 * instance per pending connection. Rendering one element per row keeps each
 * hook's attempt counter independent and the hook call count stable (hooks
 * must not be called conditionally or inside loops).
 *
 * Returns null — no DOM output.
 */
export function LedgerSyncConnectionReconciler({
  connectionId,
  reconnecting = false,
}: LedgerSyncConnectionReconcilerProps) {
  useReconcileLedgerSyncConnection(connectionId, true, reconnecting)
  return null
}
